<template>
  <GBox
    v-if="hasError"
    class="error-wrapper"
    flex
    direction="column"
  >
    <GIcon
      name="frown"
      stroke="var(--red-500)"
      size="48px"
      class="sad-icon icon"
    />
    <span
      class="text"
      @click="getCategories"
    >
      Lütfen tekrar deneyiniz.
    </span>
  </GBox>
  <GBox
    class="seller-communication-settings-wrapper"
    v-else
  >
    <GBox class="accordion-wrapper">
      <GBox
        class="accordion"
        v-for="(category, index) in categories"
        :key="'category-'+index"
      >
        <GBox
          @click="toggleVisibility(category)"
          flex
          align-items="center"
          class="header"
        >
          <GText
            variant="subtitle-02"
            color="orange-500"
            class="g-mb-10"
          >
            {{ categoryTitleTexts[category.category] }}
          </GText>
          <GIcon
            name="chevron-down"
            :class="{ rotate: category.visible }"
          />
        </GBox>
        <GBox class="body">
          <GText
            class="infoText"
            variant="body"
          >
            {{ infoTexts[category.category] }}
          </GText>
          <template v-if="category.visible">
            <GBox
              v-for="(channel,channelIndex) in category.channels"
              flex
              align-items="center"
              class="switch-wrapper"
              :key="'channel-'+channelIndex"
            >
              <GText
                class="text"
                variant="subtitle-03"
              >
                {{ channel.channelDisplayName }}
              </GText>
              <GBox
                flex
                align-items="center"
              >
                <GSwitch
                  size="small"
                  class="switch"
                  :disabled="channel.disabled"
                  v-model="channel.allowed"
                  @input="onChannelValueChange(channel, category.category)"
                />
                <GText
                  class="subtext g-ml-12"
                  variant="body"
                >
                  {{ channel.allowed ? 'Açık': 'Kapalı' }}
                </GText>
                <GBox class="tooltip-wrapper">
                  <GTooltip
                    v-if="!!tooltipText(category.category, channel.channel)"
                    :text="tooltipText(category.category, channel.channel)"
                    placement="left"
                  >
                    <template #tooltip-trigger>
                      <GIcon name="info" />
                    </template>
                  </GTooltip>
                </GBox>
              </GBox>
            </GBox>
          </template>
        </GBox>
      </GBox>
    </GBox>
    <ChangeCommunicationSettingsSurveyModal
      :show="confirmationModal.visibility"
      :channel="confirmationModal.channel"
      :title="confirmationModal.text"
      @submit="updateChannelValue"
      @close="revertChannelValue"
    />
  </GBox>
</template>

<script>
import GSwitch from '@trendyol-js/grace/core/GSwitch';
import GText from '@trendyol-js/grace/core/GText';
import GBox from '@trendyol-js/grace/core/GBox';
import GIcon from '@trendyol-js/grace/core/GIcon';
import GTooltip from '@trendyol-js/grace/core/GTooltip';
import CommunicationSettingsService from '@/services/CommunicationSettingsService';
import ChangeCommunicationSettingsSurveyModal from '@/components/Info/Modals/ChangeCommunicationSettingsSurveyModal';

export default {
  name: 'CommunicationSettings',
  components: {
    ChangeCommunicationSettingsSurveyModal,
    GSwitch,
    GText,
    GBox,
    GIcon,
    GTooltip,
  },

  props: {
    editable: {
      type: Boolean,
      required: true,
    },
  },

  data () {
    return {
      confirmationModal: {
        visibility: false,
        text: '',
        categoryIndex: '',
        channelIndex: '',
        channel: {},
      },
      activeCategory: null,
      modalTexts: {
        OPERATIONAL: {
          SMS: 'Bu tercihinizi değiştirdiğinizde Trendyol\'daki operasyonel, ticari ve finansal süreçlerinizle ilgili hiçbir SMS alamayacaksınız.',
        },
        MARKETING: {
          SMS: 'Bu tercihinizi değiştirdiğinizde kampanya, satıcı mağazası, kupon, satıcı panelindeki yenilikler ile ilgili hiçbir SMS alamayacaksınız.',
          EMAIL: 'Bu tercihinizi değiştirdiğinizde kampanya, satıcı mağazası, kupon, satıcı panelindeki yenilikler ile ilgili hiçbir e-posta alamayacaksınız.',
        },
        ORDER: {
          SMS: 'Bu tercihinizi değiştirdiğinizde siparişleriniz ile ilgili hiçbir SMS alamayacaksınız.',
          EMAIL: 'Bu tercihinizi değiştirdiğinizde siparişleriniz ile ilgili hiçbir e-posta alamayacaksınız.',
        },
        TEX: {
          SMS: 'Bu tercihinizi değiştirdiğinizde Trendyol Express ile ilgili hiçbir SMS alamayacaksınız.',
          EMAIL: 'Bu tercihinizi değiştirdiğinizde Trendyol Express ile ilgili hiçbir e-posta alamayacaksınız.',
        },
      },
      tooltips: {
        OPERATIONAL: {
          EMAIL: 'Operasyonel,ticari ve finansal konularla ilgili sizi bilgilendirmemiz gerekmektedir. Bu nedenle e-posta tercihi kapalı olarak işaretlenememektedir.',
        },
      },
      infoTexts: {
        OPERATIONAL: 'Trendyol Pazaryeri\'nde sürdürdüğünüz operasyon, ticari ve finansal süreçleriniz için gönderilen iletişimleri kapsamaktadır.',
        MARKETING: 'Trendyol Pazaryeri\'nde işinizi büyütmeniz ve geliştirmeniz için gönderilen kampanya, satıcı mağazası, kupon, satıcı panelindeki yenilikler, akademi, çözüm ortağı iletişimlerini kapsamaktadır.',
        ORDER: 'Sipariş aldığınızda tarafınıza gelen bilgilendirme iletişimlerini kapsamaktadır.',
        TEX: 'Trendyol Pazaryeri\'nde kargo operasyonları için kullandığınız Trendyol Express ile ilgili kampanya ve duyuru iletişimlerini kapsamaktadır.',
      },
      categoryTitleTexts: {
        OPERATIONAL: 'Operasyonel',
        MARKETING: 'Pazarlama Araçları',
        ORDER: 'Sipariş',
        TEX: 'Trendyol Express',
      },
      categories: [],
      hasError: false,
    };
  },

  methods: {
    tooltipText (category, channel) {
      return this.tooltips[category]
        ? this.tooltips[category][channel]
        : '';
    },
    toggleVisibility (category) {
      category.visible = !category.visible;
    },
    onChannelValueChange (channel, category) {
      if (!this.editable) {
        this.revertChannelValue({ channel });

        return this.$toast.error(
          'İletişim izinleri yalnızca Hesap Sahibi rolündeki kullanıcı tarafından değiştirilebilmektedir.',
          {
            duration: 6000,
          }
        );
      }

      if (channel.allowed) {
        this.updateChannelValue({ channel });
      } else {
        this.confirmationModal = {
          visibility: true,
          text: this.modalTexts[category][channel.channel],
          channel,
        };
      }
    },
    async updateChannelValue ({ channel, params = null }) {
      this.confirmationModal = {
        visibility: false,
        text: '',
        categoryIndex: '',
        channelIndex: '',
        channel: {},
      };
      try {
        await CommunicationSettingsService.updateCategory({
          categoryId: channel.categoryId,
          allowed: channel.allowed,
          rejectTypeReason: params ? {
            type: params.reason,
            reason: params.other,
          } : null,
        });
        this.$toast.success('İşleminiz başarı ile geçekleştirildi.', {
          duration: 5000,
        });
      } catch (err) {
        this.revertChannelValue({ channel });
      }
    },
    revertChannelValue ({ channel }) {
      setTimeout(() => {
        channel.allowed = !channel.allowed;
      }, 400);

      this.confirmationModal = {
        visibility: false,
        text: '',
        categoryIndex: '',
        channelIndex: '',
        channel: {},
      };
    },
    async getCategories () {
      try {
        this.categories = (await CommunicationSettingsService.getCategories()).categories;

        const operationalCategory = this.categories.find(cat => cat.category === 'OPERATIONAL');

        if (operationalCategory) {
          const mailChannel = operationalCategory.channels.find(ch => ch.channel === 'EMAIL');

          if (mailChannel) {
            mailChannel.disabled = true;
          }
        }

        this.categories = this.categories.map(category => ({
          ...category,
          channels: category.channels.sort((item1, item2) => item1.categoryId - item2.categoryId),
          visible: true,
        }));
      } catch (error) {
        this.$loading.hide();
        this.hasError = true;

        if (error.response) {
          (error?.response?.data?.errors || []).forEach((err) => this.$toast.error(err.message));
        } else {
          this.$toast.error(error.message || error);
        }

        throw error;
      }
    },
  },

  async created () {
    await this.getCategories();
  },
};
</script>

<style lang="scss" scoped>
@import "~@trendyol-js/grace/css/system";
  .seller-communication-settings-wrapper {
    display: flex;
    flex-direction: column;
    width: 50%;

    .accordion-wrapper{
      .accordion{
        padding-bottom: 20px;
        &:not(:first-child){
          padding-top: 20px;
          border-top: 1px solid #dddddd;
        }
        .header{
          width: 100%;
          justify-content: space-between;
          cursor: pointer;

          .rotate{
            transform: rotate(180deg);
          }
        }

        .body{
          margin-top: 10px;
        }
        .switch-wrapper{
          width: 100%;
          align-items: center;
          justify-content: space-between;
          &:not(:first-child){
            margin-top: 16px;
          }

          .subtext{
            min-width: 40px;
            display: flex;
            align-items: center;
          }
          .switch{
            max-height: 24px;
          }
        }
      }
    }
    @media only screen and (max-width: 992px) {
      width: 100%;
    }
  }
.error-wrapper{
  align-items: center;
  width: 100%;

  .text{
    font-size: 24px;
    text-decoration: underline;
    cursor: pointer;
  }
}

.tooltip-wrapper {
  width: 24px;
  height: 24px;
}

</style>
